<script setup lang="ts">
import { useLocale } from '@/plugins/translation';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

defineProps<{
  hasActiveFilters: boolean;
}>();

const { t, l } = useLocale();
</script>

<template>
  <v-btn size="48" variant="text" class="position-relative" :aria-label="t(l.search.filters)">
    <FontAwesomeIcon size="lg" icon="fa-solid fa-bars-filter"></FontAwesomeIcon>
    <FontAwesomeIcon
      v-if="hasActiveFilters"
      class="position-absolute"
      style="bottom: 8px; right: 8px"
      color="primary"
      size="2xs"
      icon="fa-solid fa-circle"
    ></FontAwesomeIcon>
  </v-btn>
</template>
